import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { Box } from '@uhg-abyss/web/ui/Box';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Button } from '@uhg-abyss/web/ui/Button';

const StyledBox = styled(Box, {
  paddingTop: '30px !important',
  paddingBottom: '30px !important',
});

const MarginTop = styled('div', {
  marginTop: 25,
});

const DialogContainer = styled('div', {
  textAlign: 'center',
  maxWidth: '80%',
  margin: '0 auto',
});

export const NotFound = () => {
  const notFoundPageDetails = {
    title: 'Page Not Found',
    desc: 'Please use the search or return home to access the page you are looking for.',
  };
  const returnToHome = () => {
    window.location.href = '#';
  };
  return (
    <PageBody data-testid="not-found-page">
      <MarginTop />
      <DialogContainer>
        <StyledBox color="white">
          <Layout.Stack alignLayout="center" space={16}>
            <IconBrand size="72" icon="alert" />
            <Heading data-testid="not-found-page-title">
              {notFoundPageDetails.title}
            </Heading>
            <Layout.Stack alignLayout="center" space={0}>
              <Text data-testid="not-found-page-desc">
                {notFoundPageDetails.desc}
              </Text>
            </Layout.Stack>
            <Button onClick={returnToHome}>Return Home</Button>
          </Layout.Stack>
        </StyledBox>
      </DialogContainer>
    </PageBody>
  );
};
